export const N68_32_33 = {
    "selectedValueColumn": "DistrictAgentCustomerGroupDistributorCustomer",
    "selectedTitle": "Product",
    "visuals": [
        {
            "title": "PESO",
            "visual": [
                {
                    "columns": 12,
                    "rows": 2,
                    "visual": {
                        "id": 1,
                        "type": "advancedTable",
                        "colorTheme": 'colorTheme1',
                        "title": "Product Compararive Monthly",
                        "binding": {
                            "data": {
                                "columns": [
                                    {
                                        "name": 'Product Name',
                                        "columnName": 'ItemName',
                                        "width": '200px',
                                        "align": "left",
                                        "sortable": true,
                                        "sum": false,
                                    },
                                    {
                                        "name": 'Jan',
                                        "columnName": 'Jan',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Feb',
                                        "columnName": 'Feb',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Mar',
                                        "columnName": 'Mar',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Apr',
                                        "columnName": 'Apr',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'May',
                                        "columnName": 'May',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Jun',
                                        "columnName": 'Jun',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Jul',
                                        "columnName": 'Jul',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Aug',
                                        "columnName": 'Aug',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Sep',
                                        "columnName": 'Sep',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Oct',
                                        "columnName": 'Oct',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Nov',
                                        "columnName": 'Nov',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Dec',
                                        "columnName": 'Dec',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Total Sales',
                                        "columnName": 'TotalSales',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    }
                                ],
                                "title": "ItemName",
                                "endpoint": "N68.32",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "DistrictAgentCustomerGroupDistributorCustomer", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {

                                    }
                                }
                            }
                        }
                    }
                }
            ]
        },
        {
            "title": "UNIT",
            "visual": [
                {
                    "columns": 12,
                    "rows": 2,
                    "visual": {
                        "id": 1,
                        "type": "advancedTable",
                        "colorTheme": 'colorTheme1',
                        "title": "Product Compararive Monthly",
                        "binding": {
                            "data": {
                                "columns": [
                                    {
                                        "name": 'Product Name',
                                        "columnName": 'ItemName',
                                        "width": '200px',
                                        "align": "left",
                                        "sortable": true,
                                        "sum": false,
                                    },
                                    {
                                        "name": 'Jan',
                                        "columnName": 'Jan',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Feb',
                                        "columnName": 'Feb',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Mar',
                                        "columnName": 'Mar',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Apr',
                                        "columnName": 'Apr',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'May',
                                        "columnName": 'May',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Jun',
                                        "columnName": 'Jun',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Jul',
                                        "columnName": 'Jul',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Aug',
                                        "columnName": 'Aug',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Sep',
                                        "columnName": 'Sep',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Oct',
                                        "columnName": 'Oct',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Nov',
                                        "columnName": 'Nov',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Dec',
                                        "columnName": 'Dec',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Total Sales',
                                        "columnName": 'TotalSales',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    }
                                ],
                                "title": "ItemName",
                                "endpoint": "N68.33",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "DistrictAgentCustomerGroupDistributorCustomer", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {

                                    }
                                }
                            }
                        }
                    }
                }
            ]
        }
    ]
}